import { ActionType, IAssetCollectionModel } from "@xala/common-services";
import { Button, Col, Form, Icon, IFormValues, Link } from "@xala/common-ui";
import { ROUTES } from "../../../constants/routes";
import { FormInstance } from "antd/lib/form";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { SelectAssetCollectionModal } from "../../SelectAssetsCollectionModal";
import { Row } from "antd";

interface IActionTypeMediaCollectionProps {
  readonly actionType: ActionType | undefined;
  readonly form: FormInstance<IFormValues>;
}

function ActionTypeMediaCollection({
  actionType,
  form,
}: Readonly<IActionTypeMediaCollectionProps>) {
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);

  if (actionType !== ActionType.OpenMediaCollection) {
    return null;
  }

  const onSelect = (collection: IAssetCollectionModel) => {
    form.setFieldsValue({
      CollactionId: collection.Id,
      CollectionName: collection.Name,
    });
    setVisible(false);
  };

  const onClear = () => {
    form.setFieldsValue({
      CollactionId: undefined,
      CollectionName: undefined,
    });
    form.resetFields(["CollactionId", "CollectionName"]);
  };

  return (
    <>
      <Form.Item name="CollactionId" noStyle required>
        <input type="hidden" />
      </Form.Item>
      <Form.Item name="CollectionName" noStyle required>
        <input type="hidden" />
      </Form.Item>
      <Form.Item
        label={t(
          "MEDIA_COLLECTION_LABEL",
          "Media Collection"
        )}
      >
        <Form.Item
          noStyle
          shouldUpdate={(prev, cur) =>
            prev.CollactionId !== cur.CollactionId ||
            prev.CollectionName !== cur.CollectionName
          }
        >
          {() => {
            const id = form.getFieldValue("CollactionId") as number | undefined;
            const name = form.getFieldValue("CollectionName") as
              | string
              | undefined;
            const hasPick =
              id != null && name != null && String(name).trim() !== "";
            const sourceValueView: React.ReactElement = hasPick ? (
              <span>
                <Link to={`${ROUTES.ASSET_COLLECTION_DETAILS}/${id}`}>
                  {name}
                </Link>
              </span>
            ) : (
              <span>
                {t(
                  "NOTIFICATION_SELECT_ASSET_COLLECTION_FIELD",
                  "Select Media Collection"
                )}
              </span>
            );
            return (
              <Row gutter={16}>
                <Col style={{ display: "flex", alignItems: "center" }}>
                  {sourceValueView}
                  <SelectAssetCollectionModal
                    visible={visible}
                    onClose={() => {
                      setVisible(false);
                    }}
                    onSelect={onSelect}
                  />
                </Col>
                <Col>
                  {hasPick ? (
                    <Button
                      icon={<Icon type="delete" />}
                      onClick={onClear}
                      style={{ marginRight: "8px" }}
                    />
                  ) : null}
                  <Button
                    icon={<Icon type="edit" />}
                    onClick={() => {
                      setVisible(true);
                    }}
                  />
                </Col>
              </Row>
            );
          }}
        </Form.Item>
      </Form.Item>
    </>
  );
}

export default ActionTypeMediaCollection;
